<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container" style="max-width: 50vw; width: 50vw; max-height: 80vh; overflow-y: auto; padding: 0; border: 4px solid #0870DC; border-radius: 8px;">
                <div class="modal-header" style="background-color: #0870DC; padding: 15px 25px !important; padding-bottom: 15px !important; display: flex; justify-content: space-between; align-items: center;">
                    <h2 style="margin: 0; color: white;">Batches for {{ stockItem.alias?.name || 'Stock Item' }}</h2>
                    <button @click.stop="closeModal()" class="red-close-button" style="margin: 0; background: #e04f39;">
                        <i class="pi pi-times" style="padding: 0;"></i>
                    </button>
                </div>
                
                <div v-if="loading" style="padding: 40px; text-align: center;">
                    <h4>Loading Batches...</h4>
                    <i class="pi pi-spin pi-spinner" style="font-size: 2.5rem !important; margin-top: 1em; color: #0870DC;"></i>
                </div>
                
                <div v-else-if="batches && batches.length" style="padding: 20px;">
                    <table style="border-collapse: collapse; width: 100%; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #f3f4f4;">
                                <th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">Batch No.</th>
                                <th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">Created Date</th>
                                <th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">Expiry Date</th>
                                <th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(batch, i) in batches" :key="i" style="border-bottom: 1px solid #ddd;">
                                <td style="padding: 10px; text-align: left; font-weight: bold;">{{ batch.batch_name }}</td>
                                <td style="padding: 10px; text-align: left;">{{ batch.created_date || 'N/A' }}</td>
                                <td style="padding: 10px; text-align: left;">{{ batch.expiry_date || 'N/A' }}</td>
                                <td style="padding: 10px; text-align: left;">
                                    <span :style="{
                                        backgroundColor: batch.status === 'Out of Stock' || batch.status === 'Expired' ? '#E04F39' : (batch.status === 'Pending' || batch.status === 'Expiring Soon' ? '#EF9600' : (batch.status === 'No Expiry' ? '#b8b8b8' : '#00AD50')),
                                        color: 'white',
                                        padding: '3px 8px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    }">
                                        {{ batch.status }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <!-- Pagination Links -->
                    <div style="display: flex; justify-content: center; align-items: center; gap: 15px; margin-top: 15px;">
                        <button 
                            v-show="totalPages > 1"
                            @click="loadPage(page - 1)" 
                            :disabled="page <= 1"
                            class="button"
                            style="margin: 0; padding: 5px 15px; height: auto; min-width: auto;"
                            :style="page <= 1 ? { background: '#ccc', cursor: 'default' } : { background: '#0870DC' }"
                        >
                            &larr; Prev
                        </button>
                        <span>Page <strong>{{ page }}</strong> of <strong>{{ totalPages }}</strong></span>
                        <button 
                            v-show="totalPages > 1"
                            @click="loadPage(page + 1)" 
                            :disabled="page >= totalPages"
                            class="button"
                            style="margin: 0; padding: 5px 15px; height: auto; min-width: auto;"
                            :style="page >= totalPages ? { background: '#ccc', cursor: 'default' } : { background: '#0870DC' }"
                        >
                            Next &rarr;
                        </button>
                    </div>
                </div>
                
                <div v-else style="padding: 40px; text-align: center;">
                    <h3>No batches found for this record.</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        stockItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            batches: [],
            page: 1,
            totalPages: 1
        };
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        loadPage(pageNum) {
            this.page = pageNum;
            this.fetchBatches();
        },
        fetchBatches() {
            this.loading = true;
            axios.post(`/stock-item/${this.stockItem.uuid}/batches?page=${this.page}`, {}, this.$store.state.header)
                .then(res => {
                    this.batches = res.data.data;
                    if (res.data.meta) {
                        this.page = res.data.meta.current_page;
                        this.totalPages = res.data.meta.last_page;
                    }
                    this.loading = false;
                })
                .catch(err => {
                    console.error('Error fetching stock item batches:', err);
                    this.loading = false;
                });
        }
    },
    mounted() {
        this.fetchBatches();
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    margin: 0px auto;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}
</style>
